import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "../components/Auth/Login";
import Dashboard from "../Pages/Dashboard";
import PageNotFound from "../Pages/PageNotFound";
import ForgetPassword from "../Pages/ForgetPassword";
import { getUserDetails } from "../api/Users";
import FullPageSpinner from "../components/Loader/FullPageSpinner";
import { get_cart_items } from "../api/Products";
import ProtectedRoute from "./ProtectedRoute";
import Requirements from "../Pages/Requirements";
import TrackRequirements from "../Pages/TrackRequirements";
import RejectedRequirements from "../Pages/RejectedRequirements";
import AddAssetType from "../Pages/AddAssetType";
import AddAssets from "../Pages/AddAssets";
import AdminDetails from "../Pages/AdminDetails";
import HostelLogin from "../Pages/HostelLogin";
import AssignHeadmaster from "../Pages/AssignHeadmaster";
import HostelReport from "../Pages/HostelReport";
import manageStock from "../Pages/ManageStocks";
import resStatusReport from "../Pages/reqStatusReport";
import CompleteRequirement from "../Pages/HostelCompleteRequirment";
import HostelRejectRequirement from "../Pages/HostelRejectedRequirment";
import ConfirmDelivery from "../Pages/ConfirmDelivery";
import StaffDetails from "../Pages/StaffDetails";
import AddStaff from "../Pages/AddStaff";
import HostelRequirement from "../Pages/HostelRequirement";
import StudentDetails from "../Pages/StudentDetails";
import AddStudent from "../Pages/AddStudent";
import HostelDashboard from "../Pages/HostelDashboard";
import AssetReport from "../Pages/AssetReport";
import RequirementsReport from "../Pages/RequirementReport";
import SchoolReport from "../Pages/SchoolReport";
import UserDetails from "../Pages/UserDetails";
import HostelDetails from "../Pages/HostelDetails";
import AddHostel from "../Pages/AddHostel";
import VendorReport from "../Pages/VendorReport";
import AllocatedAmenitiesLimits from "../Pages/AllocatedAmenitiesLimits";
// import AddNewRowTable from "../components/AddNewRowTable/AddNewRowTable";
import ChatBot from "../Pages/ChatBot";
import LimitReport from "../Pages/LimitReport";
import AmenitiesLifespan from "../Pages/AmenitiesLifespan";
import AmenitiesReport from "../Pages/AmenitiesReport";
import StudentsReport from "../Pages/StudentsReport";
import ManageStock from "../Pages/ManageStocks";
import AssignAsstHeadMaster from "../Pages/AssignAsstHeadMaster";
import LegacyReqStatusReport from "../Pages/LegacyReqStatusReport";
import UniqueCodeReport from "../Pages/UniqueCodeReport";
import AddNotice from "../Pages/AddNotice";
import ViewNotices from "../Pages/ViewNotices";
import AddGuideline from "../Pages/AddGuideline";
import ViewGuidelines from "../Pages/ViewGuidelins";
import MyProfile from "../Pages/MyProfile";
import MyLeaves from "../Pages/MyLeaves";
import MyPayroll from "../Pages/MyPayroll";
import MyStudents from "../Pages/MyStudents";
import StudentProfile from "../Pages/StudentProfile";
import AlumniStudentReport from "../Pages/AlumniStudentReport";
import StudentRequestApprovalReport from "../Pages/StudentRequestApprovalReport";
import StudentSMSReport from "../Pages/SudentSMSReport";
import StudentInformationReport from "../Pages/StudentInformationReport";
import PormoteDemoteDetainedStudentReport from "../Pages/PormoteDemoteDetainedStudentReport";
import ViewAssignmentReport from "../Pages/ViewAssignmentReport";
import TCIssueReport from "../Pages/TCIssueReport";
import UpdateStudentInformationReport from "../Pages/UpdateStudentInformationReport";
import MaleFemaleRatioReport from "../Pages/MaleFemaleRatioReport";
import MigrationFromBranchReport from "../Pages/MigrationFromBranchReport";
import MigratedtoBranchReport from "../Pages/MigratedtoBranchReport";
import DeactivatedStudentReport from "../Pages/DeactivatedStudentReport";
import NewAdmissionRatioReport from "../Pages/NewAdmissionRatioReport";
import StudentStrengthGraph from "../Pages/StudentStrengthGraph";
import LaunchSurvey from "../Pages/LaunchSurvey";
import LaunchProgram from "../Pages/LaunchProgram";
import Approve from "../Pages/Approve";
import AllSurveys from "../Pages/AllSurveys";
import AllPrograms from "../Pages/AllPrograms";
import Survey from "../Pages/Survey";
import FYBudget from "../../src/Pages/Fy_Budget_allocation";
import AddFYBudget from "../../src/Pages/AddfyAllocation";
import SampleNotice from "../Pages/SampleNotice";
import FillChecklist from "../Pages/FillChecklist";
import LimitAllocationDWO from "../Pages/LimitAllocationDWO";
import ChecklistMonitoringReport from "../Pages/ChecklistMonitoringReport";
import Fulfillment from "../Pages/Fulfillment";
import FillProgram from "../Pages/FillProgram";
import Transfer from "../Pages/Transfer";
import AllQuestions from "../Pages/AllQuestions";
import ReqFund from "../Pages/ReqFund";
import AllProgramQuestion from "../Pages/AllProgramQuestion";
import FillChecklistQuestion from "../Pages/FillChecklistQuestion";
import FundUtilization from "../Pages/FundUtilization";
import CheckListReport from "../Pages/CheckListReport";
import FillProgramQuestion from "../Pages/FillProgramQuestion";
import ProgramMonitoringReport from "../Pages/ProgramMonitoringReport";
import ProgramReport from "../Pages/ProgramReport";
import Addschool from "../Pages/Addschool";
import TransferWEO from "../Pages/TransferWEO";
import TransferDWO from "../Pages/TransferDWO";
import TransferStudent from "../Pages/TransferStudent";
import PrecurementReport from "../Pages/PrecurementReport";
import TrackRequirementsDM from "../Pages/TrackRequirementsDM";
import TeacherPrevTransferDetails from "../Pages/TeacherPrevTransferDetails";
import ContactDetail from "../Pages/ContactDetail";
import AddAssignment from "../Pages/AddAssignment";
import Assignments from "../Pages/Assignments";
import Attendance from "../Pages/Attendance";
import ViewExamMarks from "../Pages/ViewExamMarks";
import { components } from "react-select";
import TeacherProficiency from "../Pages/TeacherProficiency";
import TeacherTimeTable from "../Pages/TeacherTimeTable";
import SchoolTimeTable from "../Pages/SchoolTimeTable";
import StudentAttendanceReport from "../Pages/StudentAttendanceReport";
import BirthdayCalenderReport from "../Pages/BirthdayCalenderReport";
import CounsellingFormReport from "../Pages/CounsellingFormReport";
import SendFeedback from "../Pages/SendFeedback";
import FeedbackReport from "../Pages/FeedbackReport";
import StudentFeedback from "../Pages/StudentFeedback";
import AddActivity from "../Pages/AddActivity";
import AllActivity from "../Pages/AllActivity";
import DownloadDailyHomework from "../Pages/DownloadDailyHomework";
import ApplyStudentLeave from "../Pages/ApplyStudentLeave";
import ViewStudentLeave from "../Pages/ViewStudentLeave";
import StudentLeaveReport from "../Pages/StudentLeaveReport";
import StudentAward from "../Pages/StudentAward";
import PhotoGallery from "../Pages/PhotoGallery";
import FoodMenu from "../Pages/FoodMenu";
import FoodMenuView from "../Pages/FoodMenuView";
import BulkSms from "../Pages/BulkSms";
import AssignedTeachers from "../Pages/AssignedTeachers";
import ViewAssignedStudent from "../Pages/ViewAssignedStudent";
import BedAllotment from "../Pages/BedAllotment";
import HostelWorkersList from "../Pages/HostelWorkersList";
import ViewHostelWorkers from "../Pages/ViewHostelWorkers";
import BillManagementSystem from "../Pages/BillManagementSystem";
import HostelAttendance from "../Pages/HostelAttendance";

const AppRoutes = () => {
  const [childData, setChildData] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [role, setRole] = useState("");
  const [userData, setUserData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [mainId, setMainId] = useState("");

  const handleChildData = (data) => {
    setChildData(data);
  };

  const fetchCartItems = () => {
    return get_cart_items().then((res) => {
      if (res.status === "success") {
        setTotalItems(res.data.length);
      } else {
        setTotalItems(0);
      }
    });
  };

  async function fetchRole() {
    setIsLoading(true);
    await getUserDetails()
      .then((res) => {
        setRole(res.data.role_id);
        setMainId(res.data.user_id);
        setUserData(res);
      })
      .catch((err) => {
        console.log(err);
      });
    setIsLoading(false);
  }

  useEffect(() => {
    fetchRole();
  }, []);

  const PrivateRoutesData = [
    {
      path: "/dashboard",
      component: Dashboard,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/profile",
      component: UserDetails,
      allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    {
      path: "/managerequirements",
      component: Requirements,
      allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/bulk-approval",
      component: Approve,
      allowedRoles: [5, 6, 7, 8, 11],
    },
    {
      path: "/trackrequirements",
      component: TrackRequirements,
      allowedRoles: [1, 4, 5, 6, 7],
    },
    // {
    //   path: "/trackrequirements-DM",
    //   component: TrackRequirementsDM,
    //   allowedRoles: [7],
    // },
    {
      path: "/rejectedrequirements",
      component: RejectedRequirements,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/add-assets",
      component: AddAssets,
      allowedRoles: [1, 4],
    },
    {
      path: "/add-asset-type",
      component: AddAssetType,
      allowedRoles: [1],
    },
    {
      path: "/limits-allocation",
      component: AllocatedAmenitiesLimits,
      allowedRoles: [1, 8, 10, 11, 12, 13],
    },

    {
      path: "/create-hostel-login",
      component: HostelLogin,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 11, 12, 13, 14],
    },
    {
      path: "/add-school",
      component: Addschool,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 11, 12, 13, 14],
    },
    {
      path: "/assign-headmaster",
      component: AssignHeadmaster,
      allowedRoles: [14],
    },
    {
      path: "/liimit-allocationDWO",
      component: LimitAllocationDWO,
      allowedRoles: [6],
    },
    {
      path: "/request-budget",
      component: ReqFund,
      allowedRoles: [6],
    },
    {
      path: "/fund-utilization",
      component: FundUtilization,
      allowedRoles: [6],
    },
    {
      path: "/fy-budget-allocation",
      component: FYBudget,
      allowedRoles: [8, 10, 11, 12, 13],
    },
    {
      path: "/add-fy-allocation",
      component: AddFYBudget,
      allowedRoles: [8, 11, 12, 13],
    },
    {
      path: "/assign-asst-headmaster",
      component: AssignAsstHeadMaster,
      allowedRoles: [1, 4],
    },
    {
      path: "/add-checklist",
      component: LaunchSurvey,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/all-checklist",
      component: AllSurveys,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/fill-checklist",
      component: FillChecklist,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/fill-checklist/:id",
      component: FillChecklistQuestion,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },

    // {
    //   path: "/take-survey",
    //   component: AllSurveys,
    //   allowedRoles: [2,3,4,5,6,7,9,10,11],
    // },
    // {
    //   path: "/survey",
    //   component: Survey,
    //   allowedRoles: [2,3,4,5,6,7,9,10,11],
    // },
    {
      path: "/launch-program",
      component: LaunchProgram,
      allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/fill-program",
      component: FillProgram,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/fill-program/:id",
      component: FillProgramQuestion,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/all-programs",
      component: AllPrograms,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/hostel-report",
      component: HostelReport,
      allowedRoles: [8, 10, 11, 12, 13],
    },

    {
      path: "/assetreport",
      component: AssetReport,
      allowedRoles: [1],
    },
    {
      path: "/requirementreport",
      component: RequirementsReport,
      allowedRoles: [1],
    },
    {
      path: "/manage-stock",
      component: ManageStock,
      allowedRoles: [1, 3, 4],
    },
    {
      path: "/amenity-life-span",
      component: AmenitiesLifespan,
      allowedRoles: [1, 3, 4],
    },
    {
      path: "/amenity-report",
      component: AmenitiesReport,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/checklist-report",
      component: ChecklistMonitoringReport,
      allowedRoles: [5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/checklist-report/:id",
      component: CheckListReport,
      allowedRoles: [8, 11, 12, 13],
    },

    {
      path: "/studentRequestApproval-report",
      component: StudentRequestApprovalReport,
      allowedRoles: [4],
    },
    {
      path: "/studentSMS-report",
      component: StudentSMSReport,
      allowedRoles: [4],
    },
    {
      path: "/studentInformation-report",
      component: StudentInformationReport,
      allowedRoles: [4],
    },
    {
      path: "/promoteDemoteDetainedStudent-report",
      component: PormoteDemoteDetainedStudentReport,
      allowedRoles: [4],
    },
    {
      path: "/viewAssignment-report",
      component: ViewAssignmentReport,
      allowedRoles: [4],
    },
    {
      path: "/tCissue-report",
      component: TCIssueReport,
      allowedRoles: [4],
    },
    {
      path: "/updateStudentInformation-report",
      component: UpdateStudentInformationReport,
      allowedRoles: [4],
    },
    {
      path: "/maleFemaleRatio-report",
      component: MaleFemaleRatioReport,
      allowedRoles: [4],
    },
    {
      path: "/migrationFromBranch-report",
      component: MigrationFromBranchReport,
      allowedRoles: [4],
    },
    {
      path: "/migratedToBranch-report",
      component: MigratedtoBranchReport,
      allowedRoles: [4],
    },
    {
      path: "/deactivatedStudent-report",
      component: DeactivatedStudentReport,
      allowedRoles: [4, 9],
    },
    {
      path: "/newAdmissionRatio-report",
      component: NewAdmissionRatioReport,
      allowedRoles: [4],
    },
    {
      path: "/studentStrengthGraph-report",
      component: StudentStrengthGraph,
      allowedRoles: [4],
    },
    {
      path: "/AlumniStudent-Report",
      component: AlumniStudentReport,
      allowedRoles: [4],
    },

    {
      path: "/students-report",
      component: StudentsReport,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/req-status-report",
      component: resStatusReport,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/precurement-report",
      component: PrecurementReport,
      allowedRoles: [6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/schoolreport",
      component: SchoolReport,
      allowedRoles: [8, 10, 11, 12, 13],
    },
    {
      path: "/unique-code-report",
      component: UniqueCodeReport,
      allowedRoles: [8, 10, 11, 12, 13],
    },
    {
      path: "/hosteldetails",
      component: HostelDetails,
      allowedRoles: [1],
    },
    {
      path: "/student-details",
      component: StudentDetails,
      allowedRoles: [1, 3, 4, 9],
    },
    {
      path: "/add-student-details",
      component: AddStudent,
      allowedRoles: [1, 4],
    },
    {
      path: "/addstaff",
      component: AddStaff,
      allowedRoles: [1, 4],
    },
    {
      path: "/add-notice",
      component: AddNotice,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/view-notices",
      component: ViewNotices,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/add-guideline",
      component: AddGuideline,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/view-guidelines",
      component: ViewGuidelines,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/hostel-requirement",
      component: HostelRequirement,
      allowedRoles: [1, 4],
    },
    {
      path: "/staffdetails",
      component: StaffDetails,
      allowedRoles: [1, 3, 4],
    },
    // {
    //   path: "/addhostel",
    //   component: AddHostel,
    //   allowedRoles: [1],
    // },
    {
      path: "/vendorreport",
      component: VendorReport,
      allowedRoles: [1],
    },
    {
      path: "/completereq",
      component: CompleteRequirement,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/rejectreq",
      component: HostelRejectRequirement,
      allowedRoles: [1, 3, 4],
    },
    {
      path: "/confirmdelivery",
      component: ConfirmDelivery,
      allowedRoles: [1, 3, 4],
    },
    {
      path: "/limit-report",
      component: LimitReport,
      allowedRoles: [1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/legacy-status-report",
      component: LegacyReqStatusReport,
      allowedRoles: [8, 10, 11, 12, 13],
    },
    {
      path: "/myprofile",
      component: MyProfile,
      allowedRoles: [9],
    },
    {
      path: "/myleaves",
      component: MyLeaves,
      allowedRoles: [9],
    },
    {
      path: "/mypayroll",
      component: MyPayroll,
      allowedRoles: [9],
    },
    {
      path: "/mystudents",
      component: MyStudents,
      allowedRoles: [9],
    },
    {
      path: "/studentprofile",
      component: StudentProfile,
      allowedRoles: [10],
    },
    {
      path: "/sample-notice",
      component: SampleNotice,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      path: "/fulfillment",
      component: Fulfillment,
      allowedRoles: [6],
    },
    {
      path: "/transfer-headmaster",
      component: Transfer,
      allowedRoles: [15],
    },
    {
      path: "/transfer-WEO",
      component: TransferWEO,
      allowedRoles: [14],
    },
    {
      path: "/transfer-DWO",
      component: TransferDWO,
      allowedRoles: [14],
    },
    // {
    //   path: "/transfer-DM",
    //   component: TransferDM,
    //   allowedRoles: [14],
    // },
    {
      path: "/transfer-student",
      component: TransferStudent,
      allowedRoles: [15],
    },
    {
      path: "/all-question/:id",
      component: AllQuestions,
      allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/all-program-question/:id",
      component: AllProgramQuestion,
      allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    },
    {
      path: "/program-report",
      component: ProgramMonitoringReport,
      allowedRoles: [8, 11, 12, 13],
    },
    {
      path: "/program-report/:id",
      component: ProgramReport,
      allowedRoles: [8, 11, 12, 13],
    },

    {
      path: "/teacher-previous-transfers",
      component: TeacherPrevTransferDetails,
      allowedRoles: [4, 9],
    },
    {
      path: "/contact-details",
      component: ContactDetail,
      allowedRoles: [9],
    },
    {
      path: "/add-assignment",
      component: AddAssignment,
      allowedRoles: [9],
    },
    {
      path: "/attendance",
      component: Attendance,
      allowedRoles: [9],
    },
    {
      path: "/teacher-proficiency",
      component: TeacherProficiency,
      allowedRoles: [4, 9],
    },
    {
      path: "/teacher-timetable",
      component: TeacherTimeTable,
      allowedRoles: [9],
    },
    {
      path: "/view-exam-marks",
      component: ViewExamMarks,
      allowedRoles: [9],
    },
    {
      path: "/all-activity",
      component: AllActivity,
      allowedRoles: [9],
    },
    {
      path: "/add-activity",
      component: AddActivity,
      allowedRoles: [9],
    },
    {
      path: "/download-daily-homework",
      component: DownloadDailyHomework,
      allowedRoles: [9],
    },

    {
      path: "/assignments",
      component: Assignments,
      allowedRoles: [9],
    },
    {
      path: "/send-feedback",
      component: SendFeedback,
      allowedRoles: [9],
    },
    {
      path: "/feedback-report",
      component: FeedbackReport,
      allowedRoles: [9],
    },
    {
      path: "/student-feedback",
      component: StudentFeedback,
      allowedRoles: [9],
    },
    {
      path: "/student_apply_leave",
      component: ApplyStudentLeave,
      allowedRoles: [10],
    },
    {
      path: "/view_student_leave",
      component: ViewStudentLeave,
      allowedRoles: [9],
    },
    {
      path: "/student_leave_report",
      component: StudentLeaveReport,
      allowedRoles: [9],
    },
    {
      path: "/award_list",
      component: StudentAward,
      allowedRoles: [9],
    },
    {
      path: "/photo-gallery",
      component: PhotoGallery,
      allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    {
      path: "/food-menu",
      component: FoodMenu,
      allowedRoles: [4],
    },
    {
      path: "/food-menu-view",
      component: FoodMenuView,
      allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,14],
    },
    {
      path: "/bulk-sms",
      component: BulkSms,
      allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,14],
    },
    {
      path: "/assigned-teachers",
      component: AssignedTeachers,
      allowedRoles: [4],
    },
    {
      path: "/view-assigned-students",
      component: ViewAssignedStudent,
      allowedRoles: [9],
    },
    {
      path: "/bed-allotment",
      component: BedAllotment,
      allowedRoles: [4, 10],
    },
    {
      path: "/add-hostel-workers",
      component: HostelWorkersList,
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
    },
    {
      path: "/view-hostel-workers",
      component: ViewHostelWorkers,
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
    },
    {
      path: "/bill-management-system",
      component: BillManagementSystem,
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
    },
    {
      path: "/hostel-attendance",
      component: HostelAttendance,
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
    },
  ];

  return (
    <>
      {isLoading ? (
        <FullPageSpinner />
      ) : (
        <>
          {isLoading ? (
            <FullPageSpinner />
          ) : (
            <>
              <Router>
                <Routes>
                  <Route path="/" element={<Navigate replace to="/login" />} />
                  <Route
                    path="/login"
                    element={
                      <>
                        <Login onChildData={fetchRole} role={role} />
                        <ChatBot />
                      </>
                    }
                  />
                  <Route path="/forgotpassword" element={<ForgetPassword />} />
                  <Route path="*" element={<PageNotFound role={role} />} />
                  {PrivateRoutesData &&
                    PrivateRoutesData.map((data) => (
                      <Route
                        key={data.path}
                        path={data.path}
                        element={
                          <ProtectedRoute
                            component={data.component}
                            totalItems={totalItems}
                            role={role}
                            userData={userData}
                            allowedRoles={data.allowedRoles}
                            onChildData={handleChildData}
                            mainId={mainId}
                          />
                        }
                      />
                    ))}
                </Routes>
              </Router>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AppRoutes;
